import * as React from "react";

function UmbrellaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#3F38E0",
    d: "M15.992 7.903a8.218 8.218 0 00-7.42-6.734V0H7.427v1.17a8.218 8.218 0 00-7.42 6.733.571.571 0 00.855.588c.42-.291.912-.461 1.423-.491a2.78 2.78 0 012.366 1.435.594.594 0 00.982 0 2.869 2.869 0 011.794-1.363v5.357a1.428 1.428 0 11-2.857 0v-.286H3.43v.286a2.571 2.571 0 105.142 0V8.072a2.869 2.869 0 011.795 1.363.571.571 0 00.982 0A2.78 2.78 0 0113.714 8c.51.03 1.003.2 1.423.491a.572.572 0 00.855-.588zM2.286 6.857c-.291 0-.58.041-.86.122a7.11 7.11 0 014.85-4.465 8.295 8.295 0 00-1.74 5.105 3.74 3.74 0 00-2.25-.762zm5.714 0a3.744 3.744 0 00-2.318.818C5.704 6.406 6.03 3.966 8 2.43c1.96 1.53 2.29 3.97 2.316 5.242A3.744 3.744 0 008 6.857zm5.714 0a3.74 3.74 0 00-2.25.762 8.295 8.295 0 00-1.741-5.105 7.109 7.109 0 014.85 4.465 3.09 3.09 0 00-.859-.122z"
  }));
}

export default UmbrellaIcon;